import type { HeadContract } from '@paid-ui/types/contracts';

import { contractManager } from '../model';

export const saveLoanAndLandOwner = (contract: HeadContract | null) => {
  if (!contract) return;
  contractManager.loan = contract.loan ?? null;
  contractManager.landOwner = contract.landOwner ?? '';
};
